$(document).ready(() => {

    $('input[name="periodicity"]').on('change', function () {

       if($(this).val() === 'year'){
           $('#small-periodicity').html('Per Year');
           $('#total_cost').html($('#total_cost').data('year'));
           $('#membership_cost').html($('#membership_cost').data('year')).prepend('$');
       } else {
           $('#small-periodicity').html('Per Month');
           $('#total_cost').html($('#total_cost').data('month'));
           $('#membership_cost').html($('#membership_cost').data('month')).prepend('$');
       }
    });

    $('#btn-promo-code').on('click', function () {
        $.ajax({
            url: $(this).data('url'),
            type: 'post',
            data: {code: $('#code').val(), cost:$(this).data('cost')},
            dataType: 'json',
            statusCode: {
                200: (res) => {
                    $('#total-cost').html('$'+res.cost);
                    $('.cinvoice-promo').html(res.msg);
                },
                404: () => {
                    let div = '<div id="code-msg" class="alert alert-warning"><strong>Invalid Code</strong></div>';
                    $('.cinvoice').append(div);
                    $('#code-msg').fadeOut(2500, function () {
                        $(this).remove()
                    });
                },
            }
        })
    });

    $('input[name="options"]').on('change', function () {
        if($(this).val() === 'new'){
            $('#existing-cc').hide();
            $('#new-cc').show();
        }else{
            $('#existing-cc').show();
            $('#new-cc').hide();
        }

    });

    let $modal = $('#add-credit-card-modal');

    $modal
        .on('show.bs.modal', () => {
            $.get($modal.data('url'), (res) => {
                $modal.find('.step-content').html(res.html);
                let title = $modal.find('.step-content form').data('title');
                $modal.find('.title').text(title);
            });
        })
        .on('submit', 'form', (evt) => {

            evt.preventDefault();
            let $form = $(evt.target);
            let editDataSuccess = (res) => {
                $modal.modal('toggle');
                $('#existing-cc').html(res.html);
            };
            let editDataError = (res) => $('.step-content').html(res.responseJSON.html);

            ajaxSubmitForm($form, editDataSuccess, editDataError);

        });

    $('#purchase-form').submit(function() {
        $('#loaderImg').show();
        return true;
    });

});